import { useSearchContentHeroBannerSearchQuery } from 'domains/merchandising/api'

interface HeroBannerSearchArgs {
  retailerId: string
}

export const useContentHeroBannerSearch = ({ retailerId }: HeroBannerSearchArgs) => {
  const { data, error, loading, refetch } = useSearchContentHeroBannerSearchQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      retailerId,
    },
  })

  let banners = []

  if (data?.storefrontPlacementSearch?.edges?.length) {
    banners = data.storefrontPlacementSearch.edges.map(({ node }) => node)

    // NOTE - This is a workaround since sort does not currently work on the API
    // Sort the banners by createdAt timestamp so the newest are first
    // Replace this with sort: { field: 'CREATED_AT', sort 'DESC' } when it is ready
    banners = banners.sort(
      (a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf()
    )
  }

  return {
    banners,
    searchHeroBanners: refetch,
    apiResult: data?.storefrontPlacementSearch,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
